export const isTouchableDevice =
  typeof window !== 'undefined' && typeof window.ontouchstart !== 'undefined'

export const CONTROL_HOVER_EVENT = 'control-hover'

export const createHoverEvent = detail => new CustomEvent(CONTROL_HOVER_EVENT, { detail })
